"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var bridge_1 = require('../core/bridge');
var query_1 = require('../core/query');
var pager_1 = require('./pager');
exports.Pager = pager_1.Pager;
var EventEmitter = require('eventemitter3');
var filterObject = require('filter-object');
var Events;
(function (Events) {
    Events.SEARCH = 'search';
    Events.RESULTS = 'results';
    Events.REFINEMENT_RESULTS = 'refinement_results';
    Events.REFINEMENTS_CHANGED = 'refinements_changed';
    Events.PAGE_CHANGED = 'page_changed';
    Events.QUERY_CHANGED = 'query_changed';
    Events.RESET = 'reset';
    Events.REWRITE_QUERY = 'rewrite_query';
    Events.SORT = 'sort';
    Events.DETAILS = 'details';
    Events.REDIRECT = 'redirect';
})(Events = exports.Events || (exports.Events = {}));
var FluxCapacitor = (function (_super) {
    __extends(FluxCapacitor, _super);
    function FluxCapacitor(endpoint, config, mask) {
        if (config === void 0) { config = {}; }
        _super.call(this);
        this.originalQuery = '';
        var bridgeConfig = config.bridge || {};
        this.bridge = new bridge_1.BrowserBridge(endpoint, bridgeConfig.https, bridgeConfig);
        if (bridgeConfig.headers)
            this.bridge.headers = bridgeConfig.headers;
        this.query = new query_1.Query().withConfiguration(filterObject(config, ['*', '!{bridge}']), mask);
        this.page = new pager_1.Pager(this);
    }
    FluxCapacitor.prototype.search = function (originalQuery) {
        var _this = this;
        if (originalQuery === void 0) { originalQuery = this.originalQuery; }
        this.query.withQuery(originalQuery);
        this.emit(Events.SEARCH, this.query.raw);
        return this.bridge.search(this.query)
            .then(function (results) {
            var oldQuery = _this.originalQuery;
            Object.assign(_this, { results: results, originalQuery: originalQuery });
            if (results.redirect) {
                _this.emit(Events.REDIRECT, results.redirect);
            }
            _this.emit(Events.RESULTS, results);
            _this.emitQueryChanged(oldQuery, originalQuery);
            return results;
        });
    };
    FluxCapacitor.prototype.refinements = function (navigationName) {
        var _this = this;
        return this.bridge.refinements(this.query, navigationName)
            .then(function (results) {
            _this.emit(Events.REFINEMENT_RESULTS, results);
            return results;
        });
    };
    FluxCapacitor.prototype.rewrite = function (query, config) {
        var _this = this;
        if (config === void 0) { config = {}; }
        var search;
        if (config.skipSearch) {
            this.emitQueryChanged(this.originalQuery, query);
            search = Promise.resolve(this.query.withQuery(this.originalQuery = query));
        }
        else {
            search = this.search(query);
        }
        return search.then(function () { return _this.emit(Events.REWRITE_QUERY, query); })
            .then(function () { return query; });
    };
    FluxCapacitor.prototype.resetRecall = function () {
        this.query = new query_1.Query().withConfiguration(this.filteredRequest);
    };
    FluxCapacitor.prototype.reset = function (query) {
        var _this = this;
        if (query === void 0) { query = this.originalQuery; }
        this.resetRecall();
        this.emit(Events.PAGE_CHANGED, { pageNumber: 1 });
        return this.search(query)
            .then(function (res) { return _this.emit(Events.RESET, res); })
            .then(function () { return query; });
    };
    FluxCapacitor.prototype.resize = function (pageSize, resetOffset) {
        this.query.withPageSize(pageSize);
        if (resetOffset) {
            return this.page.switchPage(1);
        }
        else {
            var total = this.page.restrictTotalRecords(this.page.fromResult, pageSize);
            var page = this.page.getPage(total);
            return this.page.switchPage(page);
        }
    };
    FluxCapacitor.prototype.sort = function (sort, clearSorts) {
        if (clearSorts === void 0) { clearSorts = [sort]; }
        (_a = this.query).withoutSorts.apply(_a, clearSorts).withSorts(sort);
        return this.page.reset();
        var _a;
    };
    FluxCapacitor.prototype.refine = function (refinement, config) {
        if (config === void 0) { config = { reset: true }; }
        this.query.withSelectedRefinements(refinement);
        if (config.skipSearch)
            return Promise.resolve(this.navigationInfo);
        return this.doRefinement(config);
    };
    FluxCapacitor.prototype.unrefine = function (refinement, config) {
        if (config === void 0) { config = { reset: true }; }
        this.query.withoutSelectedRefinements(refinement);
        if (config.skipSearch)
            return Promise.resolve(this.navigationInfo);
        return this.doRefinement(config);
    };
    FluxCapacitor.prototype.details = function (id, navigationName) {
        var _this = this;
        if (navigationName === void 0) { navigationName = 'id'; }
        return this.bridge.search(new query_1.Query()
            .withConfiguration(this.query.raw, '{area,collection,language,fields}')
            .withSelectedRefinements({ type: 'Value', navigationName: navigationName, value: id })
            .withPageSize(1))
            .then(function (res) {
            if (res.records.length)
                _this.emit(Events.DETAILS, res.records[0]);
            return res;
        });
    };
    FluxCapacitor.prototype.switchCollection = function (collection) {
        this.query.withConfiguration({ collection: collection, refinements: [], sort: [], skip: 0 });
        return this.search();
    };
    FluxCapacitor.prototype.emitQueryChanged = function (oldQuery, newQuery) {
        if (oldQuery.toLowerCase() !== newQuery.toLowerCase()) {
            this.emit(Events.QUERY_CHANGED, newQuery);
        }
    };
    Object.defineProperty(FluxCapacitor.prototype, "filteredRequest", {
        get: function () {
            return filterObject(this.query.raw, '!{query,refinements,skip}');
        },
        enumerable: true,
        configurable: true
    });
    FluxCapacitor.prototype.resetPaging = function (reset) {
        return reset ? this.page.reset() : this.search();
    };
    FluxCapacitor.prototype.doRefinement = function (_a) {
        var _this = this;
        var reset = _a.reset;
        return this.resetPaging(reset)
            .then(function () { return _this.emit(Events.REFINEMENTS_CHANGED, _this.navigationInfo); })
            .then(function () { return _this.navigationInfo; });
    };
    Object.defineProperty(FluxCapacitor.prototype, "navigationInfo", {
        get: function () {
            return {
                available: this.results.availableNavigation,
                selected: this.results.selectedNavigation
            };
        },
        enumerable: true,
        configurable: true
    });
    return FluxCapacitor;
}(EventEmitter));
exports.FluxCapacitor = FluxCapacitor;



/*****************
 ** WEBPACK FOOTER
 ** ./~/groupby-api/dist/src/capacitor/index.js
 ** module id = 143
 ** module chunks = 0
 **/